import YInput from './src'

YInput.install = Vue => {
  Vue.component(YInput.name, YInput)
}

export default YInput
